import React from "react";
export default ({ className, onClick, disabled = false, color = null }) => (
  <svg
    className={`${className || ""} ${disabled ? "disabled" : ""}`}
    onClick={disabled ? null : onClick}
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="13" cy="13" r="13" fill="#1A1A1A" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.0385 11.2724C19.3615 12.0442 19.3615 13.9558 18.0385 14.7276L12.0077 18.2455C10.6744 19.0233 9 18.0615 9 16.5179V9.48207C9 7.93849 10.6744 6.97675 12.0077 7.75452L18.0385 11.2724Z"
      fill={color ? color : disabled ? "#4D4D4D" : "#fff"}
    />
  </svg>
);
